import { render } from "./OnDemandInstallPWA.vue?vue&type=template&id=1dcac8ca&scoped=true"
import script from "./OnDemandInstallPWA.vue?vue&type=script&lang=js"
export * from "./OnDemandInstallPWA.vue?vue&type=script&lang=js"

import "./OnDemandInstallPWA.vue?vue&type=style&index=0&id=1dcac8ca&lang=scss&scoped=true"
import "./OnDemandInstallPWA.vue?vue&type=style&index=1&id=1dcac8ca&lang=scss"

import exportComponent from "/home/runner/work/dating-app/dating-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1dcac8ca"]])

export default __exports__